import styled from "styled-components";
import { Link } from "react-router-dom";

export const Reset = styled.span`
  color: ${({ theme }) => theme.colors.chalk};
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
`;

export const List = styled.ol`
  display: flex;
  flex-direction: column;
  gap: 2px;
  list-style: none;
  margin: 0;
  padding: 0;
`;

export const Row = styled.li<{ $highlighted: boolean }>`
  align-items: center;
  background: ${({ $highlighted }) =>
    $highlighted ? "rgba(143, 169, 175, 0.1)" : "transparent"};
  border-radius: 8px;
  display: grid;
  gap: 10px;
  grid-template-columns: 22px auto 1fr auto;
  padding: 6px 8px;
`;

export const Rank = styled.span<{ $color?: string }>`
  color: ${({ $color, theme }) => $color ?? theme.colors.chalk};
  font-size: 12.5px;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
`;

export const NameLink = styled(Link)<{ $color?: string }>`
  color: ${({ $color, theme }) => $color ?? theme.colors.ice};
  font-size: 13px;
  font-weight: 700;
  overflow: hidden;
  text-decoration: none;
  text-overflow: ellipsis;
  white-space: nowrap;

  &:hover {
    text-decoration: underline;
  }
`;

export const YouLabel = styled.span`
  color: ${({ theme }) => theme.colors.chalk};
  font-size: 12px;
  font-weight: 600;
`;

export const Count = styled.span`
  color: ${({ theme }) => theme.colors.ice};
  font-size: 13px;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
`;

export const Footer = styled.div`
  align-items: center;
  background: rgba(143, 169, 175, 0.06);
  border-radius: 10px;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-top: 12px;
  padding: 10px 10px 10px 12px;
`;

export const YourRank = styled.div`
  color: ${({ theme }) => theme.colors.ice};
  display: flex;
  flex-direction: column;
  font-size: 16px;
  font-variant-numeric: tabular-nums;
  font-weight: 800;
  line-height: 1.2;

  small {
    color: ${({ theme }) => theme.colors.chalk};
    font-size: 11px;
    font-weight: 600;
  }
`;

// Ice text in every state; disabled would dim with opacity, never dark text.
export const InviteLink = styled(Link)`
  background: rgba(113, 170, 255, 0.18);
  border: 1px solid rgba(113, 170, 255, 0.45);
  border-radius: 8px;
  color: ${({ theme }) => theme.colors.ice};
  flex-shrink: 0;
  font-size: 13px;
  font-weight: 800;
  padding: 9px 14px;
  text-decoration: none;
  transition: background 120ms ease;

  &:hover,
  &:focus-visible,
  &:active {
    background: rgba(113, 170, 255, 0.28);
    color: ${({ theme }) => theme.colors.ice};
  }

  &:focus-visible {
    outline: 2px solid rgba(113, 170, 255, 0.7);
    outline-offset: 2px;
  }
`;
